import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { SelectOption } from "shared/types/Select"
import { WithClassName } from "shared/types/WithClassName"
import { BoxSelect } from "shared/ui/input/select/box/BoxSelect"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomSoundPressureLevelPresetInputProps extends WithClassName {
  hideLabel?: boolean
}

const presetOptions: SelectOption<number>[] = [
  { value: 30, label: "≤ 30" },
  { value: 35, label: "≤ 35" },
  { value: 40, label: "≤ 40" },
  { value: 45, label: "≤ 45" },
  { value: 50, label: "≤ 50" }
]

export const RoomSoundPressureLevelPresetInput = React.memo(
  ({ className, hideLabel }: RoomSoundPressureLevelPresetInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <BoxSelect.Root
        name="room.soundPressureLevel"
        label={t("Room.soundPressureLevel")}
        unit="dB(A)"
        className={classNames(
          "room-form__sound-pressure-level-preset",
          className
        )}
        readonly={isReadonly}
        disabled={isDisabled}
        data-testid="room__sound-pressure-level__box-select"
      >
        {!hideLabel && <BoxSelect.Label showUnit />}
        <BoxSelect.InfoMessage>
          {t("Room.soundPressureLevelPreset")}
        </BoxSelect.InfoMessage>
        <BoxSelect.Input options={presetOptions} />
        <BoxSelect.Readonly />
        <BoxSelect.ErrorMessage />
      </BoxSelect.Root>
    )
  }
)
